/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { eppRequest, RootState } from '@rb-serve-app/core';
import Spinner from '../../components/Spinner';
import { installMentPlans } from '@rb-serve-app/core';
import { useDispatch, useSelector } from 'react-redux';
import { EventType, useAnalytics } from '../../ui/Analytics';
import Breadcrumbs from '../../components/BreadCrumbs';
import FeatureFlagMessage from '../../components/FeatureFlagMessage';
import PlanSection from '../../components/PlanSection';
import EPPModal from '../../components/EPPModal';
import { usePlanFilters } from '../../hooks/usePlanFilters';
import { logBrazeCustomEvent } from '../../config/braze';

const EqualPaymentPlans = () => {
  const dispatch = useDispatch();
  const { trackEvent } = useAnalytics();
  const { accountId, customerId } = useSelector(
    (state: RootState) => state.user
  );

  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );
  const { eppDetails, loading: eppLoading } = useSelector(
    (state: RootState) => state.epp
  );
  const { assets } = contentfulData;

  useEffect(() => {
    trackEvent(
      EventType.PAGE_VIEW,
      'view equal payment plans',
      window.location.href
    );
    logBrazeCustomEvent('viewed_equal_payment_plan');
  }, []);

  useEffect(() => {
    if (accountId && customerId) {
      if (!eppDetails?.installData?.installmentPlans) {
        dispatch(eppRequest({ accountId, customerId }));
      }
    }
  }, [dispatch, accountId, customerId]);

  const { entries } = contentfulData;
  const contentData = entries?.rb_view_epp;
  const featureFlaggingData =
    entries?.rb_feature_flagging?.featureFlagging?.view_epp?.plan_details
      ?.terms_condition;
  const [showFeatureFlagMessage, setShowFeatureFlagMessage] = useState(false);

  const [selectedPlan, setSelectedPlan] = useState<installMentPlans | null>(
    null
  );
  const [isPendingSectionExpanded, setIsPendingSectionExpanded] =
    useState(false);

  const handleViewEPP = (plan: installMentPlans) => {
    setSelectedPlan(plan);
    trackClickEvent('view equal payment plans | view epp');
    trackEvent(
      EventType.PAGE_VIEW,
      ['modal plan details', 'enroll equal payment plans'],
      window.location.href
    );
  };

  const handleCloseModal = () => {
    setSelectedPlan(null);
    trackEvent(
      EventType.CLICK_EVENT,
      ['modal plan details', 'enroll equal payment plans'],
      window.location.href,
      'modal plan details | close'
    );
  };
  console.log('ab', eppDetails?.installData?.installmentPlans.length);

  const { activePlans, pendingPlans, completedPlans, cancelledPlans } =
    usePlanFilters({
      installmentPlans: eppDetails?.installData?.installmentPlans,
    });

  const trackClickEvent = (name: string) => {
    trackEvent(
      EventType.CLICK_EVENT,
      'view equal payment plans',
      window.location.href,
      name
    );
  };

  const togglePendingSection = () => {
    setIsPendingSectionExpanded(!isPendingSectionExpanded);
  };

  console.log('entries', entries?.rb_epp);

  return contentData ? (
    <>
      {showFeatureFlagMessage && (
        <FeatureFlagMessage className="md:left-20 left-0" />
      )}
      <div className="bg-bg-body py-4 md:px-8 px-4">
        <Breadcrumbs
          items={[
            { name: 'More', href: '/' },
            {
              name: contentData.eppTitle,
              href: '/equal-payment-plan',
            },
          ]}
        />
        <div className="bg-white p-1 rounded-lg shadow-none flex flex-1 flex-col overflow-y-scroll scrollbar-hide md:p-5 w-full mx-auto min-h-[70vh]">
          <h2
            className="md:text-[22px] font-bold text-[16px]"
            aria-label={contentData?.eppTitle}
          >
            {contentData?.eppTitle}
          </h2>

          {/* Active plans */}
          <PlanSection
            title={contentData.activeStatusTitle}
            plans={activePlans}
            loading={eppLoading || !eppDetails}
            borderColor="md:border-primary-red"
            planType="active"
            noPlansMessage={contentData.noPlansAvailable}
            className="mt-5 text-primary-red bg-red-100"
            handleViewEPP={handleViewEPP}
          />

          {/* Pending plans */}
          <PlanSection
            title={contentData.pendingPlan}
            plans={pendingPlans}
            loading={eppLoading || !eppDetails}
            borderColor="border-yellow-600"
            planType="pending"
            noPlansMessage={contentData.noPlansAvailable}
            className="mt-4 mb-2 md:mt-5 md:mb-0 text-yellow-700 bg-yellow-100"
            isCollapsible={true}
            isExpanded={isPendingSectionExpanded}
            onToggle={togglePendingSection}
            assets={assets}
            handleViewEPP={handleViewEPP}
          />

          {/* Completed plans */}
          <PlanSection
            title={contentData.completedStatusTitle}
            plans={completedPlans}
            loading={eppLoading || !eppDetails}
            borderColor="md:border-progressbar-success"
            planType="closes"
            noPlansMessage={contentData.noPlansAvailable}
            className="text-progressbar-success bg-green-100"
            handleViewEPP={handleViewEPP}
          />

          {/* Cancelled plans */}
          <PlanSection
            title={contentData.cancelledStatusTitle}
            plans={cancelledPlans}
            loading={eppLoading || !eppDetails}
            borderColor="md:border-gray-600"
            planType="cancelled"
            noPlansMessage={contentData.noPlansAvailable}
            className="text-gray-600 bg-gray-100"
            handleViewEPP={handleViewEPP}
          />
        </div>

        {/* EPP Modal */}
        <EPPModal
          selectedPlan={selectedPlan}
          onClose={handleCloseModal}
          contentData={contentData}
          entries={entries}
          featureFlaggingData={featureFlaggingData}
        />
      </div>
    </>
  ) : (
    <div className="flex justify-center items-center h-full">
      <Spinner />
    </div>
  );
};
export default EqualPaymentPlans;
